import React from "react";
import { isFrontPage } from "../FrontPage/frontPage.utils";
import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";
import { FrontPage } from "../FrontPage/FrontPage";
import { BusinessStreamPage } from "../BusinessStreamPage/BusinessStreamPage";
import { isBusinessStreamPage } from "../BusinessStreamPage/businessStreamPage.utils";
import { isSectionPage } from "../SectionPage/sectionPage.utils";
import { SectionPage } from "../SectionPage/SectionPage";
import { isArticlePage } from "../ArticlePage/articlePage.utils";
import { ArticlePage } from "../ArticlePage/ArticlePage";

interface OptimizelyPageProps {
  currentPage: OptimizelyExpandedValue;
}

export const OptimizelyPage: React.FC<OptimizelyPageProps> = ({ currentPage }) => {
  if (!currentPage) {
      return null;
  }
  if (!currentPage.contentType) {
    return null;
  }

  if (isFrontPage(currentPage)) {
    return <FrontPage content={currentPage} />
  }

  if (isSectionPage(currentPage)) {
    return <SectionPage content={currentPage}/>
  }
  
  if (isArticlePage(currentPage)) {
    return <ArticlePage content={currentPage}/>
  }

  if (isBusinessStreamPage(currentPage)) {
    return <BusinessStreamPage content={currentPage}/>
  }
}